export default __webpack_public_path__ + "static/media/copy-icon.13cd9d60.svg";